import type { SVGProps } from 'react';
const DawnFlagSK = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-SK_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-SK_svg__a)">
      <path
        fill="#0C47B7"
        fillRule="evenodd"
        d="M0 10.667h22V5.333H0z"
        clipRule="evenodd"
      />
      <path fill="#E53B35" fillRule="evenodd" d="M0 16h22v-5.333H0z" clipRule="evenodd" />
      <path
        fill="#F73744"
        stroke="#fff"
        strokeWidth={1.333}
        d="M9.978 2.533H5.736a2 2 0 0 0-1.999 1.925l-.189 5.014a2 2 0 0 0 .684 1.582l1.871 1.634a2.67 2.67 0 0 0 3.507 0l1.872-1.634a2 2 0 0 0 .684-1.582l-.19-5.014a2 2 0 0 0-1.998-1.925Z"
      />
      <mask
        id="dawn-flag-SK_svg__b"
        width={11}
        height={14}
        x={2}
        y={1}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          stroke="#fff"
          strokeWidth={1.333}
          d="M9.978 2.533H5.736a2 2 0 0 0-1.999 1.925l-.189 5.014a2 2 0 0 0 .684 1.582l1.871 1.634a2.67 2.67 0 0 0 3.507 0l1.872-1.634a2 2 0 0 0 .684-1.582l-.19-5.014a2 2 0 0 0-1.998-1.925Z"
        />
      </mask>
      <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-SK_svg__b)">
        <path
          fill="#fff"
          d="M7.333 8.867A.333.333 0 0 0 7 8.533h-.905a.333.333 0 0 1-.333-.333v-.4c0-.184.149-.333.333-.333H7c.184 0 .333-.15.333-.334v-.4A.333.333 0 0 0 7 6.4h-.381a.333.333 0 0 1-.333-.333v-.4c0-.184.149-.334.333-.334h.38c.185 0 .334-.149.334-.333v-.4c0-.184.15-.333.333-.333h.381c.185 0 .334.149.334.333V5c0 .184.149.333.333.333h.381c.184 0 .333.15.333.334v.4c0 .184-.149.333-.333.333h-.38a.333.333 0 0 0-.334.333v.4c0 .184.149.334.333.334h.905c.184 0 .333.149.333.333v.4c0 .184-.149.333-.333.333h-.905a.333.333 0 0 0-.333.334v1.466c0 .184-.15.334-.334.334h-.38a.333.333 0 0 1-.334-.334z"
        />
        <path
          fill="#1251A1"
          d="M6.911 10.74c-1.274.205-2.197.81-2.197 1.527 0 .883 1.407 1.6 3.143 1.6S11 13.15 11 12.267c0-.716-.924-1.322-2.198-1.527a1.05 1.05 0 0 0-.945-.607c-.417 0-.777.248-.946.607"
        />
      </g>
    </g>
  </svg>
);
export default DawnFlagSK;
